<!--
 * @Description: 线索管理-新增
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-04-18 17:33:12
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" :content="['expectPushInfo']" :permissionPage="permissionBase" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import baseMessage from '../../components/baseMessage.vue'
const permissionBase = {
  save: 'fbu_lead_add_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuLeadManageAdd' }
</script>
